import { Box } from "@mui/material";
import { CalendarMonth, SearchOff } from "@mui/icons-material";
import { IExamDetailsProps } from "../../Utils/Types";
import { Vocabulary } from "../../Utils/Vocabulary";
import EmptyStateCard from "../EmptyStateCard";
import ExamCard from "./ExamCard";
import styles from "../../Styles/examDetails.module.css";

/**
 * Reusable ExamDetails component for displaying exam information
 * Features:
 * - Loading state handling
 * - Empty state messages
 * - Detailed exam information display
 * - Enrollment functionality
 * - Responsive design
 */
export default function ExamDetails({
  selectedDate,
  exams = [],
  onEnrollInExam,
}: IExamDetailsProps) {

  /**
   * Render empty state when no date is selected
   */
  if (!selectedDate) {
    return (
      <Box className={styles.examDetails}>
        <EmptyStateCard
          icon={
            <CalendarMonth
              sx={{ fontSize: 48, color: "#2e3a59", opacity: 0.6 }}
            />
          }
          title={Vocabulary.selectDateToViewExams}
        />
      </Box>
    );
  }

  /**
   * Render empty state when no exams are available
   */
  if (exams.length === 0) {
    return (
      <Box className={styles.examDetails}>
        <EmptyStateCard
          icon={
            <SearchOff sx={{ fontSize: 48, color: "#2e3a59", opacity: 0.6 }} />
          }
          title={Vocabulary.noExamsAvailableForThisDay}
        />
      </Box>
    );
  }

  /**
   * Handle exam enrollment with error handling
   * @param examId - The ID of the exam to enroll in
   */
  const handleEnrollClick = (examId: string) => {
    if (onEnrollInExam) {
      onEnrollInExam(examId);
    }
  };

  /**
   * Render exam details list
   */
  return (
    <Box className={styles.examDetails}>
      {exams.map((exam) => (
        <ExamCard
          key={exam._id}
          exam={exam}
          onEnrollInExam={handleEnrollClick}
        />
      ))}
    </Box>
  );
}
